module.exports = "/packs/media/images/logo-vanguard-409bc296c657a023ed8aa802711ffee2.png";